/* unplugin-vue-components disabled */import script from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-input-button.vue?vue&type=script&setup=true&lang=ts"

import "./message-input-button.vue?vue&type=style&index=0&id=a63d6394&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a63d6394"]])

export default __exports__